import React, { useState, useEffect } from 'react';
import Form from '../form/Form';
import Task from '../task/Task';
import './ThingsToDo.css';

export default function ThingsToDo() {
    const [tasks, setTasks] = useState([]);
    const [input, setInput] = useState('');

    useEffect(() => {
        const tasksFromStorage = localStorage.getItem('tasks');
        if (tasksFromStorage) {
            setTasks(JSON.parse(tasksFromStorage));
        }
    }, []);

    useEffect(() => {
        localStorage.setItem('tasks', JSON.stringify(tasks));
    }, [tasks]);

    const addTask = (tarea) => {
        if (tarea.text.trim()) {
            tarea.text = tarea.text.trim();
            const newTasks = [tarea, ...tasks];
            setTasks(newTasks);
            setInput(''); // Limpiar el campo de entrada
        }
    };

    const handleInputChange = (e) => {
        setInput(e.target.value);
    };

    const taskDeleted = (id) => {
        const newTasks = tasks.filter((task) => task.id !== id);
        setTasks(newTasks);
    };

    const taskCompleted = (id) => {
        const newTasks = tasks.map((task) => {
            if (task.id === id) {
                task.completed = !task.completed;
            }
            return task;
        });
        setTasks(newTasks);
    };

    const taskEdited = (id, text) => {
        const newTasks = tasks.map((task) => {
            if (task.id === id) {
                task.text = text;
            }
            return task;
        });
        setTasks(newTasks);
    };

    return (
        <div className="thingsTodo-conteiner-global">
            <Form onSubmit={addTask} inputValue={input} onInputChange={handleInputChange} />
            <div className="thingsTodo-conteiner">
                <ul>
                    {tasks.map((task, index) => (
                        <li key={task.id}>
                            <Task
                                id={task.id}
                                text={task.text}
                                completed={task.completed}
                                taskDeleted={taskDeleted}
                                taskCompleted={taskCompleted}
                            />
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
